import React from 'react';
import Slider from '@wix/da-ds/pkg/Slider';

import subfolderSliderStyles from './SubfolderSlider.scss';

export interface Props {
  disableArrows?: boolean;
}

export const SubfolderSlider: React.FC<React.PropsWithChildren<Props>> = ({
  children,
  disableArrows,
}) => {
  return (
    <div className={subfolderSliderStyles['slider-wrapper']}>
      <Slider
        className={subfolderSliderStyles['slider']}
        disableArrows={disableArrows}
      >
        {children}
      </Slider>
    </div>
  );
};
SubfolderSlider.displayName = 'SubfolderSlider';

export default SubfolderSlider;
